import { Column } from "../Table/Generic";

const processColumnConfigs = (columns: Column[], visibleColumns: string[]) =>
  columns?.map((col) => {
    if (col.isDefault === undefined) {
      col.isDefault = true;
      col.isHidden = false;
    }
    if (col.isHidden === undefined) {
      col.isHidden = false;
    }
    if (!col.isDefault) {
      col.isHidden = true;
    }
    if (visibleColumns && visibleColumns.includes(col.key)) {
      col.isHidden = false;
    }
    return col;
  });

export { processColumnConfigs };
